import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft, ShieldOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';

interface AccessDeniedProps {
  /** Where the Back button goes, e.g. "/contracts". */
  backTo: string;
  /** Label for the Back button, e.g. "Back to Contracts". */
  backLabel: string;
}

/**
 * Shown in place of a page the current role may view but not change.
 * The API refuses the same action with 403; this only explains why the form is not offered.
 */
export function AccessDenied({ backTo, backLabel }: AccessDeniedProps) {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="max-w-xl mx-auto mt-12">
      <Card>
        <CardContent className="p-8 text-center">
          <ShieldOff className="h-10 w-10 mx-auto text-grey-400 mb-4" aria-hidden="true" />
          <h1 className="text-2xl font-semibold text-grey-900 mb-2">Access denied</h1>
          <p className="text-grey-600 mb-6">
            Your role ({user?.role ?? 'unknown'}) can view this area but cannot make changes. Ask an
            administrator if you need edit access.
          </p>
          <Button variant="outline" onClick={() => navigate({ to: backTo })}>
            <ArrowLeft className="h-4 w-4" />
            {backLabel}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
